export default __webpack_public_path__ + "../images/apple-touch-icon-76x76.png";